import { z } from 'zod';

// Teaching notes:
// This component is a modal form for adding a new project.
// It uses React Hook Form for form handling and Zod for validation.

const schema = z.object({
	projectName: z.string().min(1, 'Project name is required'),
	projectUrl: z.string().url(),
	projectDescription: z.string().min(10).max(500),
	projectImage: z.string().url(),
	projectTechnologies: z.array(z.string()).min(1, 'Select at least one technology'),
});

export type FormSchema = z.infer<typeof schema>;

export default schema;
